let d = document;

d.addEventListener('DOMContentLoaded', function() {
  d.querySelectorAll('.selector-wrapper [data-index="option1"]').forEach(item => {
    item.addEventListener('change', handleSizeChange)
  })
  d.querySelectorAll('.selector-wrapper [data-index="option3"]').forEach(item => {
    item.addEventListener('change', handleSizeChange)
  })
  
  d.querySelectorAll('.custom-addon-block input').forEach(item => {
    item.addEventListener('change', handleAddOnChange)
  })



  d.querySelector('[name="id"]').addEventListener('change', setAddToCartText)
  

  handleSizeChange();
  setAddToCartText();
});

function setAddToCartText(){
    let selectedVariant = d.querySelector('[name="id"]')?.value;
    let addToCartBtnText = document.querySelector(`#master-selector option[var-id="${selectedVariant}"] `)?.getAttribute('data-check')
    let addToCartButton = d.querySelector('[data-add-to-cart] span')
    if (addToCartBtnText == 'preorder'){
      addToCartButton.innerText = 'Pre Order';
      d.querySelector('.custom-atc-ship').style.display = 'block';
    }
    else {
      addToCartButton.innerText = 'Add to cart';
      d.querySelector('.custom-atc-ship').style.display = 'none';
    }
    
  }

function handleAddOnChange(e){
  debugger
  console.log('add on change ')
  let addOnTItle = e.target.getAttribute('data-title');
  e.target.parentNode.querySelector('.custom-addon-heading span ').innerHTML = addOnTItle;
  handleAdddOnChange(e);
}

function handleSizeChange(){
  let selectedCover = d.querySelector('[data-index="option3"]:checked')?.value;

  if (selectedCover !== 'Groundd Cover'){
    d.querySelectorAll('.custom-addon-block').forEach( item => item.setAttribute('hidden', 'true'));
  }
  else {
    let sizeSelected = d.querySelector('[data-index="option1"]:checked').value;
    d.querySelectorAll('.custom-addon-block').forEach( item => item.setAttribute('hidden', 'true'));
    d.querySelector(`.custom-addon-block[data-title="${sizeSelected}"]`).removeAttribute('hidden'); 
  }

  updatePrice();
}

function updatePrice(){
  let selectedCover = d.querySelector('[data-index="option3"]:checked')?.value;

  if (selectedCover == 'Groundd Cover'){
  
    let selectedSize = document.querySelector('[data-index="option1"]:checked').value;
    let selectedAddOnPrice = document.querySelector(`.custom-addon-block[data-title="${selectedSize}"] input:checked `).getAttribute('data-price');
    let price = (tempProduct.price + parseInt(selectedAddOnPrice)) / 100;
    // console.log('tempProduct.price', tempProduct.price, 'parseInt(selectedAddOnPrice)', parseInt(selectedAddOnPrice), 'price', price )
    // d.querySelector('.product__price .money').innerHTML = `$${price}`
  }
}

document.addEventListener('DOMContentLoaded', function() {
  debugger
  if (document.querySelector('.custom-addon-block') !== null) {
        document.querySelectorAll('[data-single-option-selector]').forEach(item => {
      item.addEventListener('change',   handleAdddOnChange)
    })
  }

  
  // const addonBlocks = document.querySelectorAll('.big-add-on .custom-addon-block:not([hidden="true"])');

  // addonBlocks.forEach(addonBlock => {
  //   const inputs = addonBlock.querySelectorAll('input');
  //   debugger
  //   inputs.forEach(input => {
  //     input.addEventListener('change', handleAdddOnChange);
  //   });

  // });

  // handleAdddOnChange();
  handleAdddOnChange();
});

function handleAdddOnChange() {
  const addonBlocks = document.querySelectorAll('.big-add-on .custom-addon-block:not([hidden="true"])');
  const addToCartButton = document.querySelector('[data-add-to-cart] span');
  let hasPreorder = false;
  let foundSelectedColor = false; // Move this variable outside the loop
  console.log(' you testing');
  debugger;
  addonBlocks.forEach(addonBlock => {
    const selectedAddon = addonBlock.querySelector('input:checked');
    const selectedColor = selectedAddon ? selectedAddon.getAttribute('data-title') : null;

    if (selectedAddon && selectedColor) {
      const options = addonBlock.querySelectorAll(`#master-selector_${selectedAddon.name} option`);

      Array.from(options).forEach(option => {
        const dataTitle = option.getAttribute('var-option1');
        const dataCheck = option.getAttribute('data-check');

        if (dataTitle === selectedColor) {
          foundSelectedColor = true;

          if (dataCheck === 'preorder') {
            hasPreorder = true;
            return; // Exit the loop early since we found a matching option with 'preorder'
          }
        }
      });

      if (!foundSelectedColor) {
        hasPreorder = false; // Reset hasPreorder if the selected color is not found
      }
    }
  });
  let btText= 'Add to Cart';
  let btProp= 'none';

  // check master product variant availability 
  let selectedMasterVariantId = document.querySelector('[name="id"]').value;
  let masterVarAvailability = document.querySelector(`#master-selector option[var-id="${selectedMasterVariantId}"]`).getAttribute('data-check')
    
  if (hasPreorder || masterVarAvailability == 'preorder' ) {
      btText= 'Pre Order';
      btProp= 'block';
  }
  addToCartButton.innerText = btText;
  document.querySelector('.custom-atc-ship').style.display = btProp;
}
